import { useEffect, useState } from "react";

// Returns the current Date, refreshed every `ms` (default 60s).
const useNowTick = (ms = 60000) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), ms);
    return () => clearInterval(id);
  }, [ms]);
  return now;
};

export default useNowTick;
